module.exports = __webpack_public_path__ + "img/donation-item-placeholder.svg";